import { useEffect, type ReactNode } from 'react';
import { loadGTM } from './gtm';

type GTMProviderProps = {
  children: ReactNode;
};

const GTMProvider = ({ children }: GTMProviderProps) => {
  useEffect(() => {
    loadGTM();
  }, []);

  return <>{children}</>;
};

export default GTMProvider;
